import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/CpHome";
import EmptyRouterView from "@/components/EmptyRouterView";
import Account_RegisterForm from "@/components/Account/Account_RegisterForm";
import Account_RegisterSuccess from "@/components/Account/Account_RegisterSuccess";
import MainEventInfo from "@/components/MainEventInfo";
import TripOrderReady from "@/components/TripOrderReady"
import User_Activation from "@/components/User_Activation";
import UnavailableWebsite from "@/components/UnavailableWebsite";
import DashBoard from "@/components/DashBoard";
import CustomerPage from "@/components/CustomerPage";
import UserTripList from "@/components/UserTripList";
import UserSettings from "@/components/UserSettings";
import Test from "@/components/Test";
import { store } from "../store";
import appConfig from "../../config/app_config";
import Account_Activation from '@/components/Account/Account_Activation';
import activateAccount from '@/components/activateAccount';
import Homepage from "@/components/EventRegistration/Homepage";
import PearlCalendar from "@/components/PearlCalendar";
import PassportPage from "@/components/PassportPage";
import PartnerCreation from "@/components/PartnerCreation";
import ActivityDetailScreen from "@/components/ActivityDetailScreen";
import Heinrich from "@/components/Heinrich";
import MapOverview from "@/components/Map_Overview";
import AccountReplication from "@/components/AccountReplication";
import * as dssRequest from "../api/dssRequest";
import QrScanner from "../components/QrScanner";
import ObjectManagement from "../components/ObjectManagement";
import TicketScanner from "../components/TicketScanner";
import DeliveryRouteGenerator from "../components/DeliveryRouteGenerator";
import Partner_Confirmation from "../components/Partner_Confirmation";
import User_Confirmation from "../components/User_Confirmation";
import Privacy_Statement from "../components/PrivacyStatement";
import Reviews from "../components/Reviews";

Vue.use(Router);


export default new Router({
  trailingSlashes: 'true',
  mode: 'history',
  history: true,
  routes: [
    {
      path: "/",
      name: "CustomerPage",
      component: CustomerPage,
      children: [{
        // Redirecting to Homepage
        path: "/:account_id",
        component: EmptyRouterView,
        children: [
          {
            // Redirecting to Homepage
            path: "",
            name: "Homepage",
            component: Homepage,
            meta: {
              title: 'SuperLinda - Test',
              metaTags: [
                {
                  name: 'description',
                  content: 'This is the homepage from SuperLinda - test.',
                },
                {
                  property: 'og:description',
                  content: 'This is the homepage from SuperLinda - test.'
                },
              ],
            },
            beforeEnter: (to, from, next) => {
              if (!store.getters.getRegion) {
                store.commit("setRegion", to.params.account_id);
              }

              const userId = store.getters['auth/userName'];
              if (userId === '') {
                // User not logged in, go to login page
                next({
                  path: "/" + to.params.account_id + '/login'
                });
              } else {
                // User logged in, redirect to admin home page - dashboard
                if (store.getters["auth/userLevel"] >= 6 && store.getters["auth/userLevel"] <= 9) {
                  next({
                    path: "/" + to.params.account_id + '/dashboard'
                  });
                }
              }
            },
          },
          {
            // Redirecting to Login page
            // Redirecting to Login page
            path: "login",
            name: 'Login',
            component: Login,
            beforeEnter: (to, from, next) => {
              if (!store.getters.getRegion) {
                store.commit("setRegion", to.params.account_id);
              }
              next({});
            }
          },
          {
            // Redirecting to Login page
            path: "privacy-statement",
            name: "PrivacyStatement",
            component: Privacy_Statement,
          },
          {
            // Path to follow after payment redirection
            path: "payments/redirect/:paymentId",
            name: "TripOrderReady",
            component: TripOrderReady,
            beforeEnter: (to, from, next) => {

              if (!store.getters.getRegion) {
                store.commit("setRegion", to.params.account_id);
              }
              next({});
            }
          },
          {
            // Redirecting to register page
            path: "register",
            name: "Register",
            component: Account_RegisterForm,
          },
          {
            // Redirect to register success page
            path: "uniqueId=:uniqueId",
            name: "AccountRegisterSuccess",
            component: Account_RegisterSuccess
          },
          {
            //ToDo the calendar is still not working for partner and account
            //calendars parent container
            path: "calendar-booking",
            component: EmptyRouterView,
            children: [
              {
                // Redirecting to calendar
                path: "",
                name: "Calendar",
                component: PearlCalendar,
              },
              {
                // Redirecting to calendar for partner
                path: ":partner_id",
                name: "PartnerCalendar",
                component: PearlCalendar,
              }
            ]
          },
          {
            // Redirecting to passport page (settings)
            path: "my-account",
            name: "PassportPage",
            component: PassportPage,
          },
          {
            // Redirecting to passport page (settings)
            path: "reviews",
            name: "Reviews",
            component: Reviews,
          },
          {
            // Redirecting to passport page (settings)
            path: "partner-creation",
            name: "PartnerCreation",
            component: PartnerCreation,
          },
          {
            // Redirecting to TripList page
            path: "tripList",
            name: "TripList",
            component: UserTripList,
          },

          {
            // Redirecting to object management page
            path: "management",
            name: "ObjectManagement",
            component: ObjectManagement,
          },

          {
            // Redirecting to activate user page
            path: "activateUser",
            name: "ActivateUser",
            component: User_Activation,
          },
          {
            // redirecting to activate account page
            path: "activateAccount",
            name: "ActivateAccount",
            component: Account_Activation,
            beforeEnter: (to, from, next) => {
              console.log("Brian are we getting here ?!?! it should be namelijk!", );

              next({});
            }
          },
          {
            // redirecting to partner confirmation page
            path: "partnerConfirmation",
            name: "PartnerConfirmation",
            component: Partner_Confirmation
          },
          {
            // redirecting to partner confirmation page
            path: "userConfirmation",
            name: "userConfirmation",
            component: User_Confirmation
          },
          {
            // redirecting to activate account page
            path: "ticketScanner",
            name: "TicketScanner",
            component: TicketScanner,
          },
          {
            // redirect to dashboard
            path: "qrscanner",
            name: "QrScanner",
            component: QrScanner,
            props: true,
            beforeEnter: (to, from, next) => {

              /**
               * important check to avoid switching account id keeping the administrator rights
               */
              // let enabled = false;
              const user = store.getters["auth/user"];
              const accountId = store.getters.getCurrentAccountId;
              // user.tags.forEach(e => {
              // if (e.AccountId == accountId && e.Description == "Administrator" && e.Selected == "yes")
              // enabled = true;
              // })

              if (store.getters["auth/userLevel"] >= 6 && store.getters["auth/userLevel"] <= 9) { //Administrator/Partner
                next();
              } else {
                next({
                  path: "/" + to.params.account_id
                });
              }
            }
          },
          {
            // Redirecting to deliveryRouteGenerator page (settings)
            path: "delivery",
            name: "DeliveryRouteGenerator",
            component: DeliveryRouteGenerator,
            beforeEnter: (to, from, next) => {
              if (store.getters["auth/userLevel"] === 6) { //Partner
                next();
              } else {
                next({
                  path: "/" + to.params.account_id
                });
              }
            }
          },
          {
            // redirecting to test scanner account page
            path: "test",
            name: "Test",
            component: Test,
          },
          {
            // redirecting to activate account page
            path: "accountPreferences",
            name: "setNewAccountPreferences",
            component: Account_Activation,
          },
          {
            // Path to account replication page
            path: "account-replication",
            name: "AccountReplication",
            component: AccountReplication,
          },
          {
            // Redirect to mainEventInfo page
            path: "main/:type",
            name: "MainEventInfo",
            component: MainEventInfo,

            beforeEnter: (to, from, next) => {
              if (store.getters["auth/userLevel"] >= 0) { //at least user
                if (store.getters["auth/userLevel"] != 9) {
                  if (to.params.type != 'u') {
                    next({
                      path: from.fullPath
                    });
                  }
                }
                next({});
              } else {
                next("/");
              }
            }
          },
          {
            // Redirecting to event overview
            path: "event=:event_id",
            name: "ActivityDetailScreen",
            component: ActivityDetailScreen,
            beforeEnter: (to, from, next) => {
              /**
               * important check to check if customer visualizes their event
               */
              if (to.params.event_id !== null && to.params.event_id !== undefined) {

                store.commit("setChosenEvent", to.params.event_id);
                store.commit("setRedirectedFromWebToEvent", true);
                store.commit("setRegion", to.params.account_id);
                next({});
              }
              else {
                next({
                  path: "/" + to.params.account_id
                });
              }

            }
          },
          {
            // redirect to dashboard

            // For admin web, we use DashBoard as the new HomePage

            path: "dashboard",
            name: "DashBoard",
            component: DashBoard,
            props: true,
            beforeEnter: (to, from, next) => {
              if (!store.getters.getRegion) {
                store.commit("setRegion", to.params.account_id);
              }

              /**
               * important check to avoid switching account id keeping the administrator rights
               */
              const user = store.getters["auth/user"];
              const accountId = store.getters.getCurrentAccountId;

              if (store.getters["auth/userLevel"] >= 6 && store.getters["auth/userLevel"] <= 9) { //Administrator/Partner
                next();
              } else {
                next({
                  path: "/" + to.params.account_id
                });
              }
            }
          },
        ]
      },

        //         {
        // // Redirect to register success page
        //           path: "/submitted/:uniqueId/:userType",
        //           name: "AccountRegisterSuccess",
        //           component: Account_RegisterSuccess
        //         }


        //end of new way of routing



      ]
    },
    // {
    // // Test Homepage page
    // path: "/:account_id/:event_id",
    // name: "ActivityDetailScreen",
    // component: ActivityDetailScreen,
    // beforeEnter: (to, from, next) => {
    //
    // /**
    // * important check to check if customer visualizes their event
    // */
    // if (to.params.event_id !== null || to.params.event_id !== undefined) {
    //
    // store.commit("setChosenEvent", to.params.event_id);
    // store.commit("setRedirectedFromWebToEvent", true);
    // store.commit("setRegion", to.params.account_id);
    // next({
    // path: "/activitydetails/u/" + to.params.account_id
    // });
    // }
    // else {
    // next({
    // path: "/home/" + to.params.type + "/" + to.params.account_id
    // });
    // }
    // }
    // },
    // {
    // path: "/:account_id",
    // name: "Home",
    // component: Homepage,
    // props: true,
    // beforeEnter: (to, from, next) => {
    // store.commit("setRegion", to.params.account_id);
    // next({
    // path: "/home/u/" + to.params.account_id
    // });
    // }
    // },
    // {
    // path: "/home",
    // name: "Home",
    // component: Homepage,
    // props: true,
    // beforeEnter: (to, from, next) => {
    // //
    // if (store.getters.getRegion) {
    // next({
    // path: "/home/" + to.params.type + "/" + store.getters.getRegion
    // });
    // }
    // }
    // },
    // {
    // path: "/home/:type",
    // name: "Home",
    // component: Homepage,
    // props: true,
    // beforeEnter: (to, from, next) => {
    // //
    // if (store.getters.getRegion) {
    // next({
    // path: "/home/u/" + store.getters.getRegion
    // });
    // }
    // }
    // },
    // {
    // path: "/test/:type/:account_id",
    // name: "Test",
    // component: Test,
    // props: true,
    // // beforeEnter: (to, from, next) => {
    // // if (store.getters["auth/userLevel"] >= 6 && store.getters["auth/userLevel" <= 9]) { //Administrator
    // // next();
    // // } else {
    // // next("/");
    // // }
    // // }
    // },
    // {
    // path: "/heinrich/:type/:account_id",
    // name: "Heinrich",
    // component: Heinrich,
    // props: true,
    // // beforeEnter: (to, from, next) => {
    // // if (store.getters["auth/userLevel"] >= 6 && store.getters["auth/userLevel" <= 9]) { //Administrator
    // // next();
    // // } else {
    // // next("/");
    // // }
    // // }
    // },
    // {
    // path: "/dashboard/:type/:account_id",
    // name: "DashBoard",
    // component: DashBoard,
    // props: true,
    // beforeEnter: (to, from, next) => {
    //
    // /**
    // * important check to avoid switching account id keeping the administrator rights
    // */
    // // let enabled = false;
    // const user = store.getters["auth/user"];
    // const accountId = store.getters.getCurrentAccountId;
    // // user.tags.forEach(e => {
    // // if (e.AccountId == accountId && e.Description == "Administrator" && e.Selected == "yes")
    // // enabled = true;
    // // })
    //
    // if (store.getters["auth/userLevel"] >= 6 && store.getters["auth/userLevel"] <= 9) { //Administrator/Partner
    // next();
    // } else {
    // next({
    // path: "/home/" + to.params.type + "/" + to.params.account_id
    // });
    // }
    // }
    // }
  ]
});



